import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { z } from "zod";
import { RecipeDetailsCreate } from "@/components/views/recipes/recipe-details-create";
import { ContainerSmall } from "@/components/primitives/container-small";
import { PageContainer } from "@/components/primitives/layout";
import { auth } from "@/lib/auth";
import { db, machines } from "@/db/index.server";
import { optionalStringSearchParam } from "@/lib/searchParams";
import { eq, isNull, or } from "drizzle-orm";
import { sortMachines } from "@/components/views/calculator/utils";

const searchSchema = z.object({
  type: optionalStringSearchParam,
});

const getNewRecipeData = createServerFn({ method: "GET" }).handler(async () => {
  const request = getRequest();
  const session = await auth.api.getSession({ headers: request.headers });

  if (!session) return null;

  const machinesData = await db
    .select()
    .from(machines)
    .where(
      or(eq(machines.createdBy, session.user.id), isNull(machines.createdBy)),
    );

  return { machines: sortMachines(machinesData) };
});

export const Route = createFileRoute("/recipes/new")({
  validateSearch: searchSchema,
  head: () => ({
    meta: [{ title: "New Recipe - Scoopulator" }],
  }),
  loader: async () => {
    const data = await getNewRecipeData();
    if (!data) throw redirect({ to: "/sign-in" });
    return data;
  },
  component: RecipeNewPage,
});

function RecipeNewPage() {
  const { machines } = Route.useLoaderData();

  return (
    <PageContainer>
      <ContainerSmall>
        <RecipeDetailsCreate machines={machines} />
      </ContainerSmall>
    </PageContainer>
  );
}
